'use strict';

namespace Attractions {

    class Overlay {

        isActive: boolean = false;
        el: JQuery;
        elParent: JQuery;

        constructor (clickFn: Function) {
            let className = 'attractions-calendar-overlay';
            this.el = $(`.${className}`);

            if (!this.el.length) {
                this.el = $(`<div class="${className}" />`)
                    .appendTo('body')
                    .click(clickFn);
            }
            this.elParent = this.el.parent();
        }

        show (): void {
            this.isActive = true;
            this.el.show();
        }

        resize (winWidth: number): void {
        // Sets width to window unless window is smaller than parent
            this.el.css({
                width: Math.max(this.elParent.width(), winWidth)
            });
        }

        hide (): void {
            this.isActive = false;
            this.el.hide();
        }
    }

    class AttractionsCalendar {

        win: JQuery;
        html: JQuery;
        datepicker: any;
        datepickerEl: any;
        overlay: Overlay;
        parentForm: any;
        legend: any[] = [];
        debouncedOnRender: () => void;
        debouncedSetLayout: () => void;
        dpPosFn: () => any;
        eventNs: string = '.ac';
        htmlCss: any = {};

        // Attr
        select: Function;
        minDate: string;
        maxDate: string;
        enabledDates: any = {};
        renderedDates: any = {};
        currentDate: string;
        activeDateFrom: string;
        placeholder: string;

        selectedDate: Date | any = this.dateUtil.parseDate(this.currentDate);


        constructor (
            private $scope,
            private $filter,
            private $window,
            private $q,
            private dateUtil,
            private attractionService,
            private resourceService: Core.ResourceService
        ) {
            $(() => {
                if (!$.datepicker._updateDatepicker_original) {
                    // Add `afterShow` event to jquery datepicker
                    // https://bugs.jqueryui.com/ticket/6885
                    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
                    $.datepicker._updateDatepicker = function(inst) {
                        $.datepicker._updateDatepicker_original(inst);
                        var afterShow = this._get(inst, 'afterShow');
                        if (afterShow) {
                            afterShow.apply((inst.input ? inst.input[0] : null));
                        }
                    };
                }
                this.win = $($window);
                this.html = $('html');
                this.debouncedOnRender = _.debounce(() => this.onRender(), 100);
                this.debouncedSetLayout = _.debounce(() => this.setLayout(), 100);
                this.overlay = new Overlay(() => this.datepicker('hide'));
            });
        }

        init (inputEl: JQuery): void {
            this.$q.when(this.selectedDate || this.getFirstPopulatedDate(0))
                .then(date => this.selectedDate = date)
                .then(() => this._init(inputEl));
        }

        _init (inputEl: JQuery): void {
            let currDate = new Date();

            // Initialise jQuery datepicker http://api.jqueryui.com/datepicker/
            inputEl.datepicker({
                numberOfMonths: 1,
                dateFormat: 'dd-M-yy',
                firstDay: 1,
                defaultDate: this.selectedDate,
                minDate: this.dateUtil.parseDate(this.minDate),
                maxDate: this.dateUtil.parseDate(this.maxDate),
                beforeShowDay: date => this.filterDate(date),
                beforeShow: () => {
                    this.enabledDates = {};
                    this.datepickerEl.addClass('attractions-calendar');
                    this.suppressPositioning();
                    this.lockScroll();
                    this.getAvailability(
                        this.selectedDate ||
                        this.activeDateFrom ||
                        new Date(currDate.getFullYear(), currDate.getMonth())
                    );
                    this.overlay.show();

                    return !inputEl.lastDisplay ||
                        (new Date().getTime() - inputEl.lastDisplay > 100);
                },
                afterShow: () => {
                    if (this.overlay.isActive) {
                        inputEl.blur(); // IE fix cursor showing through overlay
                        this.createHeader();
                        this.debouncedOnRender();
                        this.win.on('resize' + this.eventNs, () => this.debouncedSetLayout());
                    }
                },
                onChangeMonthYear: (y, m) => {
                    if (this.overlay.isActive) {
                        this.getAvailability(new Date(y, m - 1)); // Month is 0 based
                    }
                },
                onSelect: () => {
                    this.selectDate();
                    // http://www.objectpartners.com/2012/06/18/jquery-ui-datepicker-ie-focus-fix/
                    inputEl.lastDisplay = new Date().getTime();
                    inputEl.blur();
                },
                onClose: () => {
                    this.win.off(this.eventNs);
                    this.overlay.hide();
                    this.renderedDates = {};
                    this.datepickerEl.removeClass('active');
                    this.restoreScroll();

                    // This deals with anything typed into the field that changed the value
                    let dpDate = this.datepicker('getDate') || '',
                        expected = this.selectedDate || '';
                    if (dpDate.toString() !== expected.toString()) {
                        this.selectDate();
                    }
                    else {
                        this.syncField();
                    }
                    // Put back positioning for any other datepickers
                    this.restorePositioning();
                },
                isRTL: TRPCONFIG.Rtl
            });

            if (TRPCONFIG.IsTouchDevice) {
                inputEl.attr('readonly', 'true');
            }

            this.datepicker = inputEl.datepicker.bind(inputEl);
            this.datepickerEl = $('#ui-datepicker-div');
            this.watchDateAttr('minDate', 'maxDate');

            this.$scope.$watch('ac.parentForm.formModel.date', (value) => {
                if (value == null) {
                    this.clearDate();
                }
            });
        }

        getFirstPopulatedDate(monthsFromToday: number) {
            if (monthsFromToday > 12) {
                return null;
            }
            let date = this.dateUtil.todayPlus( { months: monthsFromToday} );
            return this.attractionService.getAvailability(
                this.parentForm.productId,
                angular.extend({}, this.parentForm.formModel, { date: date })
            )
            .then(res => {
                const dateIdx = this.getFirstAvailableDateWithTicketsIdx(res);
                const firstDateWithTickets = _.get(res, `Dates[${dateIdx}].Date`);

                let firstDate = _.get(res, 'Dates[0].Date');

                if (this.activeDateFrom) {
                    if (this.dateUtil.compareDates(this.activeDateFrom, firstDateWithTickets) === -1) {
                        firstDate = firstDateWithTickets;
                    } else {
                        firstDate = this.activeDateFrom;
                    }
                }
                if (firstDate) {
                    return this.dateUtil.parseDate(firstDate);
                } else {
                    return this.getFirstPopulatedDate(monthsFromToday + 1);
                }
            });
        }

        getFirstAvailableDateWithTicketsIdx (res) {
            return _.findIndex(res.Dates, (obj: any) => {
                return obj.Tickets && obj.Tickets.length > 0;
            });
        }

        getDateKey (date) {
            return this.dateUtil.format(date, 'yyyy-MM-dd');
        }

        filterDate (date) {
            let isEnabled = true; // Default to allowing date
            if (this.enabledDates) {
                if (!this.enabledDates[this.getDateKey(date)]) {
                    isEnabled = false;
                }
                if (this.activeDateFrom && this.dateUtil.compareDates(this.activeDateFrom, date) === 1
                    && this.dateUtil.compareDates(date, this.dateUtil.addDays(this.minDate, -1, null)) === 1) {
                    return [isEnabled, 'ui-datepicker-inactive', ''];
                }
            }
            return [isEnabled, '', ''];
        }

        watchDateAttr (...attr): void {
            this.$scope.$watchGroup(attr.map(k => 'ac.' + k), vals => {
                vals.forEach((v, i) => {
                    if (this.datepicker && v != null) {
                        this.datepicker('option', attr[i], this.dateUtil.parseDate(v));
                    }
                });
            });
        }

        showLoading (delay: number): number {
            let spinnerHtml = '<div class="preloader circular large">',
                i = 8;
            while (i--) {
                spinnerHtml += `<div class="cell cell-${i+1}"></div>`;
            }
            return setTimeout(() => {
                $(spinnerHtml + '</div>').hide().fadeIn(1000)
                    .appendTo(this.datepickerEl);
            }, delay);
        }

        hideLoading (): void {
            this.datepickerEl.find('.preloader').hide();
        }

        lockScroll (): void {
            this.htmlCss = {
                overflowY: this.html.css('overflowY'),
                width: 'auto'
            };
            this.html.css({
                overflowY: 'hidden',
                width: $('body').outerWidth()
            });
        }

        restoreScroll (): void {
            this.html.css(this.htmlCss);
        }

        setLayout (): void {
            let winWidth = this.win.width(),
                winHeight = TRPCONFIG.Domain.DeviceType === 'Mobile' ?
                    screen.height : // ios fix
                    this.win.height();

            // Allow for mobile fixed header
            let header = $('.header-main'),
                headerOffset = header.css('position') === 'fixed' ?
                    header.outerHeight() : 0;

            this.overlay.resize(winWidth);
            this.win.scrollLeft(0); // input focus can cause window to scroll away
            this.datepickerEl.css({
                left: winWidth / 2,
                top: $(document).scrollTop() - headerOffset,
                'max-width': winWidth,
                'max-height': winHeight
            });
        }

        onRender (): void {
        // For new months this may run both before and after `getAvailability()`
            this.datepickerEl.addClass('active');
            this.populateDates();
            this.setLayout();
        }

        getAvailability (date: Date): void {
            // `renderedDates` suppresses re-rendering a month until calendar is closed
            let dateKey = this.getDateKey(date);

            if (!this.renderedDates[dateKey]) {
                let spinnerTimer = this.showLoading(300);

                return this.attractionService.getAvailability(
                        this.parentForm.productId,
                        angular.extend({}, this.parentForm.formModel, {date: date})
                    )
                    .then(res => {
                        let dates = res.Dates;
                        clearTimeout(spinnerTimer);

                        if (res.error) {
                            this.hideLoading();
                        }
                        else {
                            this.legend = _.filter(res.Legend, (o: any) => o.Abbreviation);
                            dates.forEach(o => {
                                let dateStr = this.getDateKey(o.Date);
                                if (dateStr && _.get(o, 'Tickets.length', 0) > 0) {
                                    this.enabledDates[dateStr] = this.sortTickets(
                                        o.Tickets,
                                        this.legend.reduce(
                                            (o, l, i) => (o[l.Label] = i+1) && o, {}
                                        )
                                    );
                                }
                            });
                            this.renderedDates[dateKey] = true;
                            this.datepicker('refresh'); // Destroys spinner
                        }
                    });
            }
        }

        sortTickets (tickets, order) {
            return tickets.sort((a, b): number =>
                order[a.Label] < order[b.Label] ? -1 :
                order[a.Label] > order[b.Label] ? 1 : 0
            );
        }

        syncField (): void {
            // Ensure field contains current value
            this.datepicker('setDate', this.selectedDate);
        }

        getLegendChar (key: string): string {
            return (_.find(this.legend, {
                    Key: key
                }) || {}).Abbreviation || '';
        }

        getPriceHtml (key: string) {
            let htmlStr = '',
                enabledDates = this.enabledDates[key];

            if (enabledDates) {
                if (enabledDates.length < 3) {
                    // Placeholder for spacing
                    htmlStr += '<div class="price"></div><br>';
                }
                htmlStr += enabledDates.reduce((str, ticket) =>
                    `${str}<div class="label">${
                        this.getLegendChar(ticket.Key)
                    }</div><div class="price">${
                        this.$filter('roundedCurrency')(ticket.Price)
                    }</div><br>`, '');
            }
            return htmlStr;
        }

        zeroPad (n) {
            n += '';
            return ('00' + n).substr(n.length);
        }

        populateDates (): void {
            // Populate data on active calendar DOM elements (only)
            $('.attractions-calendar [data-month]').each((i, el) => {
                let $el = $(el),
                    key = $el.attr('data-year') + '-' +
                          this.zeroPad(Number($el.attr('data-month')) + 1) + '-' + // Month is 1 based
                          this.zeroPad($el.text()); // Seems jQuery datepicker is designed this way `_selectDay()`

                // NOTE: <div> required even if there's no price data
                $el.append(`<div class="price-wrapper">
                                <div class="price-text">${this.getPriceHtml(key)}</div>
                            </div>`);
            });
        }

        createHeader (): void {
            let closeBtn = $(`<div class="close"><i class="icon-close"></i></div>`)
                    .click(() => this.datepicker('hide'));

            let legendArea = !this.legend.length ? '' :
                `<ul class="legend">${
                    this.legend.reduce((str, o) => `${str}
                        <li><span class="label">${o.Abbreviation}</span>${o.Label}</li>
                    `, '')
                }</ul>`;

            let headerArea = $(`
                    <div class="header-area">
                        <h5>${this.resourceService.get('ATTRACTIONSCALENDARHEADER')}</h5>
                        <div class="header-area-notification sc-c-notification sc-c-notification--highlight">
                            ${this.resourceService.get('ATTRACTIONBOOKINGNOTE')}
                        </div>
                    </div>`);
            let legendAreaConainer = $(`
                <div class="header-area">
                    ${legendArea}
                </div>
            `);
            this.datepickerEl.append(legendAreaConainer);
            headerArea.append(closeBtn);
            this.datepickerEl.prepend(headerArea);
        }

        clearDate (): void {
            this.selectedDate = null;
            this.syncField();
            this.selectDate();
        }

        selectDate (): void {
            let dateOb;
            this.selectedDate = this.datepicker('getDate') || this.selectedDate;

            if (this.dateUtil.isValid(this.selectedDate)) {
                dateOb = new Date(
                    this.selectedDate.getFullYear(),
                    this.selectedDate.getMonth(),
                    this.selectedDate.getDate()
                );
            }

            this.$scope.$evalAsync(() => {
                if (this.selectedDate == null) {
                    this.select({ date: null });
                }
                else {
                    // Add price data to parent form for displaying total
                    let dateData = this.enabledDates[this.getDateKey(this.selectedDate)];
                    if (dateData) {
                        dateData.forEach(d => {
                            this.parentForm.setPriceData(d.Key, d.Price);
                        });
                    }
                    this.select({
                        date: this.dateUtil.serialiseDate(dateOb)
                    });
                }
                this.syncField();
            });
        }

        suppressPositioning (): void {
        // Suppress datepicker absolute positioning
            this.dpPosFn = $.datepicker._checkOffset;
            $.datepicker._checkOffset = () => ({left:'', top:''});
        }

        restorePositioning (): void {
            $.datepicker._checkOffset = this.dpPosFn;
        }

        deregister (): void {
            // Clear class for any other datepickers
            this.datepickerEl.removeClass('attractions-calendar');
            this.win.off(this.eventNs);
            $.datepicker._updateDatepicker = $.datepicker._updateDatepicker_original;
            delete $.datepicker._updateDatepicker_original;
        }

    }

    angular
        .module('TR')
        .directive('attractionsCalendar', (): ng.IDirective => {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: AttractionsCalendar,
            controllerAs: 'ac',
            bindToController: {
                select: '&',
                minDate: '=',
                maxDate: '=',
                currentDate: '=',
                activeDateFrom: '=',
                placeholder: '@'
            },
            require: '^attractionsProductForm',
            template: `<div class="date-picker">
                        <div class="input-with-icon toggle">
                            <span class="field-icon icon-calendar"></span>
                            <input type="text" placeholder="{{ac.placeholder}}" />
                        </div>
                    </div>`,
            link: (
                scope: any,
                el: JQuery,
                attr: ng.IAttributes,
                attractionsProductForm: any
            ) => {
                scope.ac.parentForm = attractionsProductForm;
                scope.ac.init(el.find('input'));
                scope.$on('$destroy', () => scope.ac.deregister());
            }
        };
    });
};
